import MultiSelectWithSearch from 'components/common/MiltiSelectSearch'
import { useEffect, useState } from 'react'
import FilterMenu from '../../../common/FilterMenu'
import { ExtensionStatus } from '../../../../redux/slices/apps.slice'
import './extensionFilters.scss'

interface ExtensionFiltersMenuProps {
  onClose?: () => void
  onApplyFilters: (filters: any) => void
  currentFilters: any
}

const STATUS_OPTIONS = [
  { value: ExtensionStatus.Available, label: ExtensionStatus.Available },
  { value: ExtensionStatus.InCall, label: ExtensionStatus.InCall },
  { value: ExtensionStatus.Ringing, label: ExtensionStatus.Ringing },
  { value: ExtensionStatus.Offline, label: ExtensionStatus.Offline },
  { value: 'DND', label: 'DND' },
]

export default function ExtensionFiltersMenu({ 
  onClose, 
  onApplyFilters, 
  currentFilters 
}: ExtensionFiltersMenuProps) {
  const [localFilters, setLocalFilters] = useState<any>({})

  useEffect(() => {
    setLocalFilters(currentFilters || {})
  }, [currentFilters])

  const handleFilterChange = (fieldName: string, value: any) => {
    setLocalFilters((prev: any) => ({ ...prev, [fieldName]: value }))
  }

  const handleApply = () => {
    onApplyFilters(localFilters)
    onClose?.()
  }

  const handleClear = () => {
    const cleared = Object.keys(localFilters || {}).reduce((acc: any, key: string) => {
      acc[key] = null
      return acc
    }, {})
    setLocalFilters(cleared)
  }

  return (
    <FilterMenu onClose={onClose} onApply={handleApply} onClear={handleClear}>
      <ExtensionFilterFields
        localFilters={localFilters}
        handleFilterChange={handleFilterChange}
      />
    </FilterMenu>
  )
}

interface ExtensionFilterFieldsProps {
  localFilters: any
  handleFilterChange: (fieldName: string, value: any) => void
}

export function ExtensionFilterFields({ 
  localFilters, 
  handleFilterChange 
}: ExtensionFilterFieldsProps) {
  return (
    <div className="filter-field">
      <div className="label">Status</div>
      <MultiSelectWithSearch
        className="call-center-multisearch"
        placeholder="Select Status"
        value={localFilters.status || []}
        onChange={(value) => handleFilterChange('status', value)}
        options={STATUS_OPTIONS}
      />
    </div>
  )
}

